import { IBigBannerSlide } from '../_Slide/models';
import React, { FC, useCallback } from 'react';
import { Button, IButtonProps } from '@src/atoms/Button';
import { useEventEmitter } from '@src/hooks/useEventEmitter';
import { CENTRA_EVENT_ROUTES, CENTRA_ROUTE_SCHEMA } from '@src/consts/common';
import { getInternalEventName, isEvent } from '@src/utils/events';
import { TChangeFeedbackData } from '../models';
import { toDownFirstSymbol } from '@src/utils/string';

export type TBigBannerSlideButtonProps = Pick<IBigBannerSlide, 'linkText' | 'link'> & {
  changeFeedbackData: TChangeFeedbackData;
};

export const BigBannerSlideButton: FC<TBigBannerSlideButtonProps> = ({ changeFeedbackData, link, linkText }) => {
  const text = linkText || 'Посмотреть';
  const emitter = useEventEmitter();

  const handleClick = useCallback(() => {
    if (link.startsWith(CENTRA_ROUTE_SCHEMA)) {
      const result = getInternalEventName(link);

      if (CENTRA_EVENT_ROUTES.FEEDBACK === result.event && result.params?.formId) {
        /** Понизим первый символ, т.к. часто с бека приходит в верхнем регистре */
        const formType = toDownFirstSymbol(result.params.formId);

        changeFeedbackData({
          formType,
          data: result.params,
        });
      }
    } else {
      emitter.emit(link);
    }
  }, [emitter, link, changeFeedbackData]);

  const props: Partial<IButtonProps> = isEvent(link)
    ? { onClick: handleClick }
    : {
        href: link,
        target: link.startsWith('https://') ? '_blank' : '_self',
        disableNextJs: true,
      };

  return (
    <>
      <Button view="secondaryDark" {...props} id={'bannerActionBtn'}>
        {text}
      </Button>
    </>
  );
};
